/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Special_Needs_Education26Inputs */

const en__field_enum_study_special_needs_education26 = /** @type {(inputs: _Field_Enum_Study_Special_Needs_Education26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Special Needs Education`)
};

const de__field_enum_study_special_needs_education26 = /** @type {(inputs: _Field_Enum_Study_Special_Needs_Education26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehramt für Förderschulen`)
};

/**
* | output |
* | --- |
* | "Special Needs Education" |
*
* @param {_Field_Enum_Study_Special_Needs_Education26Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_special_needs_education26 = /** @type {((inputs?: _Field_Enum_Study_Special_Needs_Education26Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Special_Needs_Education26Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_special_needs_education26(inputs)
	return de__field_enum_study_special_needs_education26(inputs)
});
export { _field_enum_study_special_needs_education26 as "_field_enum_STUDY_SPECIAL_NEEDS_EDUCATION" }